import { Button, CustomDatePicker, Switch } from "components/ui";
import React, { useRef } from "react";
import { useState, useEffect } from "react";
import AnalyticsFilterDuration from "./AnalyticsFilterDuration/AnalyticsFilterDuration";
import AnalyticsFilterType from "./AnalyticsFilterType/AnalyticsFilterType";
import AnalyticsFilterValues from "./AnalyticsFilterValues/AnalyticsFilterValues";
import { useDispatch } from "react-redux";
import { updateCurrentAnalyticsCustomDate } from "store/analytics/actions";
import { formdateDatePickerDate } from "utils/helper";
import "./AnalyticsFilters.scss";


const AnalyticsFilters = ({
    defaultRequest,
    updateRequest,
    handleSubmit,
    options,
    setOptions,
    showOnlyDuration,
    isLoading,
    showAIButton,
    setSelectedOptions,
    selectedOptions,
    currentAnalyticsCustomDate,
    toggleAIAssistance,
}) => {
    const {
        analyticsRequestType,
        analyticsRequestValue,
        analyticsRequestDuration,
    } = defaultRequest || {};

    const spacerRef = useRef(null);
    const filterRef = useRef(null);
    const [isSticky, setIsSticky] = useState(false);
    const [loading, setLoading] = useState(false);
    const [localOptions, setLocalOptions] = useState(selectedOptions);
    const dispatch = useDispatch();
    const computedShowDate = analyticsRequestDuration === 'CUSTOM_DATE';
    const [showDate, triggerShowDate] = useState(computedShowDate);

    const handleSpecialRequest = (key, value) => {
        updateRequest(key, value);
        triggerShowDate(value === "CUSTOM_DATE" ? true : false);
        showOnlyDuration && handleSubmit();
    };

    const handleCustomDate = (date) => {
        const startDate = date[0];
        const endDate = date[1];
        if (startDate && endDate) {
            dispatch(
                updateCurrentAnalyticsCustomDate({
                    startDate,
                    endDate,
                })
            );
        }
    };

    const handleBaseFilterChange = (key, value) => {
        if (key === 'analyticsRequestType') {
            setLocalOptions([]);
        }
        updateRequest(key, value);
    };

    useEffect(() => {
        // Try to find the main scrollable container
        const scrollableParent = document.querySelector('.auth-page') || document.documentElement;
        
        const handleScroll = () => {
            if (filterRef.current) {
                // const rect = filterRef.current.getBoundingClientRect();
                const shouldBeSticky = scrollableParent.scrollTop > 0;
                setIsSticky(shouldBeSticky);
            }
        };

        // Initial check
        handleScroll();
        
        scrollableParent.addEventListener('scroll', handleScroll, { passive: true });
        return () => scrollableParent.removeEventListener('scroll', handleScroll);
    }, []);


    return (
        <div className="analytics__filter" ref={filterRef}>
            <div className="analytics__filter__wrapper">
                <div
                    className={`analytics__filter__spacer ${isSticky ? 'analytics__filter__spacer--active' : ''}`}
                    ref={spacerRef}
                ></div>
                <div className="analytics__filter analytics__filter--fixed">
                    <form
                        onSubmit={async (e) => {
                            e.preventDefault();
                            await setSelectedOptions(localOptions);
                            handleSubmit();
                        }}>
                        <div className='analytics-filter__switch'>
                            {showAIButton && (
                                <Switch
                                    // checked={fals}
                                    label='AI Assisted'
                                    id='ai-assisted'
                                    useColor={false}
                                    onChange={(state) => toggleAIAssistance(state)}
                                />
                            )}
                        </div>

                        <div className='analytics-filter row'>
                            <div
                                className={`${showDate ? "col-4" : "col-2"
                                    } analytics-filter__duration-select`}>
                                <AnalyticsFilterDuration
                                    defaultValue={analyticsRequestDuration}
                                    updateRequest={handleSpecialRequest}
                                />

                                {(showDate ||
                                    analyticsRequestDuration === "CUSTOM_DATE") && (
                                        <CustomDatePicker
                                            onChange={handleCustomDate}
                                            placeholder={"Date"}
                                            startDate={formdateDatePickerDate(
                                                currentAnalyticsCustomDate?.startDate
                                            )}
                                            endDate={formdateDatePickerDate(
                                                currentAnalyticsCustomDate?.endDate
                                            )}
                                            otherClassNames={"analytics-filter__date-range"}
                                            selectsRange
                                        />
                                    )}
                            </div>

                            {!showOnlyDuration && (
                                <div
                                    className={`row ${showDate ? "col-6" : "col-8"
                                        } analytics-filter__group`}>
                                    <div className='col-3'>
                                        <AnalyticsFilterType
                                            defaultValue={analyticsRequestType}
                                            handleBaseFilterChange={handleBaseFilterChange}
                                        // handleBaseFilterChange={updateRequest}
                                        />
                                    </div>
                                    <div className='col-9'>
                                        <AnalyticsFilterValues
                                            key={analyticsRequestType}
                                            analyticsRequestType={analyticsRequestType}
                                            defaultValue={analyticsRequestValue}
                                            updateRequest={updateRequest}
                                            setLoading={setLoading}
                                            useCustomDate={showDate}
                                            setSelectedOptions={setLocalOptions}
                                            selectedOptions={localOptions}
                                            {...{
                                                options,
                                                setOptions
                                            }}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className='col-2'>
                                {!showOnlyDuration && (
                                    <Button
                                        text='Apply all'
                                        classType='apply'
                                        otherClass='analytics-filter__button'
                                        disabled={loading || isLoading || (analyticsRequestValue ? localOptions?.length === 0 : false)}
                                    />
                                )}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AnalyticsFilters;
